'use client'

import { useContext, useEffect, useRef } from 'react'

import { SSEEventData, EventTypes } from '@marketplace-web/messaging/sse-connection-data'
import { useMessagingSSEConnection } from '@marketplace-web/messaging/sse-connection-feature'

import { ConversationListContext } from '@marketplace-web/messaging/conversation-providers-feature'

export const useHandleConversationListSSE = () => {
  const { updateConversation } = useContext(ConversationListContext)
  const { subscribeToMessageUpdates, unsubscribeFromMessageUpdates } = useMessagingSSEConnection()
  const updateConversationRef = useRef(updateConversation)

  useEffect(() => {
    updateConversationRef.current = updateConversation
  }, [updateConversation])

  const handleMessageUpdate = (data: SSEEventData) => {
    const sseConversationId = data.data.user_msg_thread_id

    if (data.message_type !== EventTypes.RefreshConversation) return
    if (!sseConversationId) return

    updateConversationRef.current({ id: sseConversationId })
  }

  useEffect(() => {
    subscribeToMessageUpdates(handleMessageUpdate)

    return () => {
      unsubscribeFromMessageUpdates(handleMessageUpdate)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
